<div class="bg-white p-5">
  <h2 class="text-xl font-bold mb-4 text-dc-navy">
    {{ "ACCOUNT.ACCESS.TITLE" | translate }}
  </h2>
  @if(loadingSrDetail){
  <app-skeleton-loader
    [formLoader]="true"
    [noOfFields]="7"
  ></app-skeleton-loader>
  } @if(!loadingSrDetail && requestDetail){
  <!-- ============ General information ============ -->
  <div class="border-b-2 border-gray-200">
    <h3 class="text-lg font-bold text-dc-black mb-4">
      {{ "ACCOUNT.ACCESS.GENERAL" | translate }}
    </h3>
  </div>
  <table class="dc-table-list">
    <tbody>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.EN_NAME" | translate }}
        </td>
        <td>{{ requestDetail["DC Created User Full Name"] }}</td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.AR_NAME" | translate }}
        </td>
        <td>-</td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.NATIONALITY" | translate }}
        </td>
        <td>{{ requestDetail["DC Created User Nationality"] }}</td>
      </tr>
    </tbody>
  </table>

  <!-- ============ Roles ============ -->
  <div class="border-b-2 border-gray-200">
    <h3 class="text-lg font-bold text-dc-black mb-4">
      {{ "ACCOUNT.ACCESS.ROLES" | translate }}
    </h3>
  </div>
  <table class="dc-table-list">
    <tbody>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.USER_TYPE" | translate }}
        </td>
        <td>
          <!-- {{requestDetail["DC Created User Type"]}} -->
          @if(requestDetail){
          <div class="block">
            @if(requestDetail['DC Link Mem Answer1'] == "Y"){
            <span class="w-full">{{
              this.lang == "ar" ? roles[0].label_ar : roles[0].label
            }}</span
            >, } @if(requestDetail['DC Link Mem Answer2'] == "Y"){
            <span class="w-full">{{
              this.lang == "ar" ? roles[0].label_ar : roles[1].label
            }}</span
            >, } @if(requestDetail['DC Link Mem Answer3'] == "Y"){
            <span class="w-full">{{
              this.lang == "ar" ? roles[0].label_ar : roles[2].label
            }}</span>
            }
          </div>
          }
        </td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.ACCESS" | translate }}
        </td>
        <td>-</td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.LEGAL_STATUS" | translate }}
        </td>
        <td>{{ requestDetail["DC Legal Status"] }}</td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.ISSUE_DATE" | translate }}
        </td>
        <td>-</td>
      </tr>
    </tbody>
  </table>

  <!-- ============ Contact ============ -->
  <div class="border-b-2 border-gray-200">
    <h3 class="text-lg font-bold text-dc-black mb-4">
      {{ "ACCOUNT.ACCESS.CONTACT" | translate }}
    </h3>
  </div>
  <table class="dc-table-list">
    <tbody>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.PHONE" | translate }}
        </td>
        <td>{{ requestDetail["DC Created User Phone Number"] }}</td>
      </tr>
      <tr>
        <td>
          {{ "ACCOUNT.ACCESS.EMAIL" | translate }}
        </td>
        <td>{{ requestDetail["DC Created User Email"] }}</td>
      </tr>
    </tbody>
  </table>

  <!-- action buttons -->
  <div class="flex flex-wrap gap-3 mt-6">
    <app-button
      [label]="'ACCOUNT.ACTIONS.APPROVE' | translate"
      classesName="btn-edge-cut"
      (onBtnClick)="approveRejectRequest('approve', requestDetail)"
    >
    </app-button>

    <app-button
      [label]="'ACCOUNT.ACTIONS.REJECT' | translate"
      classesName="card-edge-cut-white"
      (onBtnClick)="approveRejectRequest('reject', requestDetail)"
    >
    </app-button>
  </div>
  }
</div>

@if (showApproveAccessConfirmation) {
<app-confirmation-modal
  [message]="'ACCOUNT.ACCESS_REQUEST.UPDATE_SERVICE_ACCESS_MESSAGE'"
  [confirmLabel]="'BUTTONS.OK'"
  [showCancel]="false"
  (confirm)="confirmApproveAccessConfirmation()"
></app-confirmation-modal>
}
